import { OrganizationReportRegistrationEntity } from '../entities/';
import { authResource } from './Auth';
import { schema } from '@data-client/rest';
export const OrganizationReportRegistrationResource = authResource({
    path: '/organizations/:organizationId/reports/registrations/:registrationId?',
    searchParams: {},
    schema: OrganizationReportRegistrationEntity
}).extend('getList', {
    schema: {
        counts: new schema.Collection([OrganizationReportRegistrationEntity]),
        items: new schema.Collection([OrganizationReportRegistrationEntity])
    }
});
